import { useMutation } from '@tanstack/react-query';
import dataService from 'services/dataService';
import { showResult } from 'infrastructure/hooks/utils';

import type {
  IBatchClearingData,
  IBatchClearingResponse,
} from 'infrastructure/interfaces/i-rpm-patient-activity';

const mutationFn = async (postData: IBatchClearingData) => {
  const url = 'core-2/patients/readings/actions/batch-clearing';
  const { error, data } = await dataService.createOne<IBatchClearingResponse>(
    url,
    postData,
  );

  if (error) {
    showResult(error);
    throw new Error(error);
  }

  return data;
};

export const useBatchClearing = () => {
  const { mutate, isLoading } = useMutation({
    mutationFn,
  });
  return {
    batchClearing: mutate,
    isLoading,
  };
};
